export const SITE_CONFIG = {
    companyName: "ProDevop (Pvt) Ltd",
    companyShortName: "ProDevop",
    registrationNumber: "PV 00339671",
    tagline: "Mistakes Make Me Perfect.",
    description: "ProDevop is a digital solutions company in Sri Lanka building custom websites, e-commerce platforms, POS and inventory systems, mobile applications, branding, digital marketing, and UI/UX design for startups and growing businesses.",
    founder: "Mr. Sivakolonthu Danushkan",
    founderRole: "Founder & CEO",
    phone: "+94770707698",
    phoneDisplay: "+94 77 070 7698",
    email: "info.prodevop@gmail.com",
    website: "https://prodevop.com",
    location: "Kandy, Sri Lanka",
    locationCity: "Kandy",
    locationCountry: "Sri Lanka",
    businessHours: "Monday – Saturday, 9:00 AM – 5:00 PM",
    responseTime: "We respond within 24 hours.",
    whatsappUrl: "https://wa.me/94770707698",
    whatsappMessage: "Hello ProDevop, I would like to discuss my project requirements and receive a quotation.",

    // Primary and secondary call-to-action wording used across the site.
    cta: {
        primary: "Get a Free Quote",
        secondary: "Chat on WhatsApp",
    },

    // Only confirmed, active company profiles are listed here.
    // Do not add a profile until it exists and is publicly reachable.
    social: {
        facebook: "https://www.facebook.com/profile.php?id=61585751196602",
        instagram: "https://www.instagram.com/prodevop.pvt.ltd/",
    },

    academy: {
        name: "D CODE ACADEMY",
        tagline: "Mistakes Make Me Perfect.",
        description: "ProDevop's A/L ICT education initiative, supporting Tamil-medium students through theory classes, revision classes, paper classes, model exams, webinars, and recorded lessons.",
        youtube: "https://www.youtube.com/@d.code.academy",
        facebook: "https://www.facebook.com/profile.php?id=61591233364938",
        whatsappChannel: "https://whatsapp.com/channel/0029Vb854Jq42DcZ71tHWs2T",
    },
};

/**
 * Builds a properly encoded WhatsApp enquiry link.
 * Pass a service name to generate a service-specific pre-filled message.
 */
export function buildWhatsAppLink(serviceName) {
    const message = serviceName
        ? `Hello ProDevop, I'm interested in ${serviceName}. I would like to discuss my requirements and receive a quotation.`
        : SITE_CONFIG.whatsappMessage;
    return `${SITE_CONFIG.whatsappUrl}?text=${encodeURIComponent(message)}`;
}
